import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const SOCIALS = [
  { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/lli.hyd" },
  { Icon: Facebook, label: "Facebook", href: "https://www.facebook.com/share/1J1oqN5EdZ/" },
  { Icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/learninglightsinitiative/" },
  { Icon: Youtube, label: "YouTube", href: "https://youtube.com/@learninglightsinitiative" },
];

export const Footer = () => (
  <footer className="bg-forest text-bone pt-20 pb-10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-bone/15">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="bg-bone px-2 py-1.5 inline-flex">
              <img src="/logo-mark.png" alt="Learning Lights Initiative logo" className="h-9 w-auto" />
            </span>
            <span className="font-sans font-extrabold text-lg tracking-tight uppercase leading-tight">Learning Lights<br /><span className="text-xs font-semibold tracking-[0.3em] text-bone/60">Initiative</span></span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-bone/60 max-w-sm">
            An education NGO transforming government schools across Hyderabad &amp;
            Ranga Reddy, Telangana — one classroom at a time.
          </p>
          <div className="mt-6 flex gap-3" data-testid="footer-socials">
            {SOCIALS.map(({ Icon, label, href }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Learning Lights Initiative on ${label}`} data-testid={`footer-social-${label.toLowerCase()}`}
                className="w-10 h-10 border border-bone/25 flex items-center justify-center hover:bg-terra hover:border-terra transition-colors duration-200">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-xs font-bold tracking-[0.25em] uppercase text-bone/50 mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            {[["manifesto", "Manifesto"], ["programs", "Programs"], ["impact", "Impact"], ["contact", "Contact"]].map(([id, label]) => (
              <li key={id}>
                <a href={`/#${id}`} onClick={(e) => { e.preventDefault(); scrollToId(id); }} data-testid={`footer-link-${id}`}
                  className="text-bone/75 hover:text-terra transition-colors">{label}</a>
              </li>
            ))}
            <li><Link to="/blog" data-testid="footer-link-journal" className="text-bone/75 hover:text-terra transition-colors">Journal</Link></li>
            <li><Link to="/careers" data-testid="footer-link-careers" className="text-bone/75 hover:text-terra transition-colors">Careers</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="text-xs font-bold tracking-[0.25em] uppercase text-bone/50 mb-5">Reach Us</h4>
          <ul className="space-y-3 text-sm text-bone/75">
            <li>Email — <a href="mailto:info_lli@learninglightsinitiative.org" className="hover:text-terra transition-colors" data-testid="footer-email-link">info_lli@learninglightsinitiative.org</a></li>
            <li>Phone — <a href="tel:+919392590701" className="hover:text-terra transition-colors" data-testid="footer-phone-link">+91 93925 90701</a></li>
            <li>Field Office — Plot no. 57, Sai Ram Nagar, Puppalaguda, Hyderabad 500089</li>
          </ul>
          <Link to="/admin/login" data-testid="footer-admin-link" className="inline-block mt-6 text-xs font-bold tracking-[0.2em] uppercase text-bone/40 hover:text-terra transition-colors">
            Admin Login
          </Link>
        </div>
      </div>
      <div className="pt-8 flex flex-wrap items-center justify-between gap-4">
        <p className="text-xs text-bone/45">© {new Date().getFullYear()} Learning Lights Initiative. Every lamp lit lights another.</p>
        <p className="font-serif italic text-bone/45 text-sm">"Education is the lamp we pass on."</p>
      </div>
    </div>
  </footer>
);
